export const getChangedParentFields = ( oldProposal: Record<string, any> | null, newProposal: Record<string, any> ) => {
    if (!oldProposal) return {};

    const changes: Record<string, any> = {};

    Object.keys(newProposal).forEach((key) => {
        const oldValue = oldProposal[key];
        const newValue = newProposal[key];

        if (JSON.stringify(oldValue) !== JSON.stringify(newValue)) {
            changes[key] = newValue;
        }
    });

    return changes;
};